import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from 'vue'

  import GetStartedPanel from '@/components/GetStartedPanel.vue'
  import CourseBundleTestimonials from '@/components/CourseBundleTestimonials.vue'
  import BrandBar from '@/components/BrandBar.vue'
  import CoursePanel from '@/components/CoursePanel.vue'
  import DashboardFAQs from '@/components/common/DashboardFAQs.vue'
  import BaufiUpsell from '@/components/course/BaufiUpsell.vue'
  import BuyPackageDetails from '@/components/course/course-panel-contents/BuyPackageDetails.vue'

  import useCommonMixin from '@/composables/useCommonMixin'
  import useI18n from '@/composables/useI18n'
  import useCourse from '@/composables/useCourse'
  import useSegment from '@/composables/useSegment'

  import { UserModule } from '@/store/modules/user'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Dashboard',
  setup(__props) {

  const { extractCourseVertical, is34ACompany } = useCommonMixin()
  const { translateString } = useI18n()
  const { course, courseBundle, purchasedCourses } = useCourse()
  const { pageViewed, trackPage } = useSegment()

  const courseVertical = computed(() => (courseBundle.value ? extractCourseVertical(courseBundle.value.title) : null))

  const introDescriptionText = computed(() => {
    if (courseBundle.value) {
      return translateString('homepage.introDescription', {
        jobTitle: courseBundle.value.jobTitle,
        courseVertical: courseVertical.value,
      })
    }
    return ''
  })

  const showBaufiUpsell = computed(() => {
    if (!purchasedCourses.value.length) return false

    const baufiUpsellCourseIds = ['63d7d5bb-e8e9-429d-b360-cefdecd80448', '489dd660-9a78-4f94-8076-1e8f20a451e2']
    const purchasedCoursesIds = purchasedCourses.value.map((course) => course.id)
    return baufiUpsellCourseIds.some((id) => purchasedCoursesIds.includes(id)) && !!course.value?.baufiCourseDetails?.id
  })

  const showBuyPackageDetails = computed(() => {
    return (
      courseBundle.value?.courses.every((course) => !course.purchased) && courseBundle.value?.shopifyProductVariantId
    )
  })

  onMounted(() => {
    pageViewed('Dashboard')
    trackPage('Dashboard')
  })

return { __sfc: true,extractCourseVertical, is34ACompany, translateString, course, courseBundle, purchasedCourses, pageViewed, trackPage, courseVertical, introDescriptionText, showBaufiUpsell, showBuyPackageDetails, computed, onMounted, GetStartedPanel, CourseBundleTestimonials, BrandBar, CoursePanel, DashboardFAQs, BaufiUpsell, BuyPackageDetails, useCommonMixin, useI18n, useCourse, useSegment, UserModule }
}

})